// @owners { team: patients }
import {
  SnoozeOptionsEndpoint,
  type SnoozeOptionsEndpointFetchByShipmentRequest,
  type SnoozeOptionsEndpointFetchByShipmentResponse,
} from '@alto/scriptdash/alto/patient_app/scheduling/v1/snooze_options_endpoint';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { apiEndpointHandler } from '~shared/helpers/api';
import { getErrorMessageFromResponse } from '~shared/helpers/helper';

const snoozeOptionsEndpoint = SnoozeOptionsEndpoint(apiEndpointHandler);

export const snoozeOptions = createQueryKeys('snoozeOptions', {
  fetchByShipment: (params: SnoozeOptionsEndpointFetchByShipmentRequest) => ({
    queryKey: [params],
    queryFn: async (): Promise<SnoozeOptionsEndpointFetchByShipmentResponse> => {
      const response = await snoozeOptionsEndpoint.fetchByShipment(params);
      if (response.errors?.length) {
        throw new Error(getErrorMessageFromResponse({ errors: response.errors }));
      }
      return response;
    },
  }),
});
